<template>
  <div class="tab_list">
    <custom-plane>
      <div class="table-top">
        <div class="name">配电设备查询</div>
        <div class="table-search">
          <div class="top-input-ele">
            <el-input
              placeholder="请输入设备名称"
              v-model="searchValue1"
              clearable
              @clear="getRecentData"
            >
            </el-input>
          </div>
          <div class="top-btn" @click="chooseTable" ref="test">搜索</div>
        </div>
      </div>
      <div class="bot-table">
        <div class="custom-table-header">
          <div
            class="table-column-item"
            v-for="(item, index) in header"
            @click="changeUp(item)"
            :key="'x' + index"
          >
            <div class="text">
              <div class="text-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <template v-if="FtableData.length != 0">
          <div
            class="custom-table-body mens"
            ref="listsTable"
            @scroll="scrollEvent"
          >
            <div class="custom-table-wrap" ref="tableWrap">
              <div
                class="custom-table-item"
                :class="{
                  menoff: getMenoff(index),
                  itemSelect: data.eqpName == selectIndex,
                }"
                v-for="(data, index) in FtableData"
                @click="clickEvent(data, index)"
                :key="'c' + index"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="data.installPos"
                  placement="bottom"
                >
                  <div>{{ data.installPos }}</div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="data.number"
                  placement="bottom"
                >
                  <div>{{ data.number }}</div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="data.eqpName"
                  placement="bottom"
                >
                  <div>{{ data.eqpName }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isLoadEnd">
          <div class="bot-bg">
            <div class="bot-bg-hidden noData"></div>
            <div class="bot-bg-name">未搜索到该设备</div>
          </div>
        </template>
        <template v-else>
          <div class="bot-bg">
            <div class="bot-bg-hidden">
              <div class="loading">
                <div class="outer"></div>
                <div class="middle"></div>
                <div class="inner"></div>
              </div>
            </div>
            <div class="bot-bg-name">数据加载中...</div>
          </div>
        </template>
      </div>
    </custom-plane>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
export default {
  name: "table-list",
  props: {
    header: Array,
    tableData: Array,
    isLoadEnd: Boolean,
  },

  data() {
    return {
      selectIndex: null,
      searchValue1: "", //设备
      startValue: 0,
      endValue: 0,
      isScroll: false,
      isHidden: false,
      selectData: "PDJ_A",
      FtableData: this.tableData,
    };
  },
  computed: {},
  mounted() {
    // 监听父传来的是A或B配电间
    bus.on("tableData", (data) => {
      this.selectData = data;
    });
  },
  watch: {
    // 默认显示A配电间数据
    tableData() {
      // this.FtableData = this.tableData.filter((item) => {
      //   return item.number.slice(0, 1).includes("A");
      // });
      if (this.selectData == "PDJ_D") {
        this.mySearchB();
      } else {
        this.mySearchA();
      }
    },
    // 监听点击的事A或B配电间
    selectData(newVal) {
      if (newVal == "PDJ_D") {
        this.mySearchB();
      } else {
        this.mySearchA();
      }
    },
  },
  methods: {
    scrollEvent(e) {
      if (e.target.scrollTop >= this.FtableData.length * 46 - 365) {
        e.target.scrollTop = 0;
      }
    },
    // A配电间对应数据
    mySearchA() {
      this.FtableData = this.tableData.filter((item) => {
        return item.number.slice(0, 1).includes("A");
      });
    },
    // B配电间对应数据
    mySearchB() {
      this.FtableData = this.tableData.filter((item) => {
        return item.number.slice(0, 1).includes("B");
      });
    },
    // 点击的变配电数据模型对焦
    clickEvent(data, i) {
      this.selectIndex = data.eqpName;
      bus.emit("substationData", data.eqpCode);
      this.$emit("nowClickData", data);
    },
    getMenoff(index) {
      if (this.startValue % 2 == 0) {
        return index % 2 !== 0;
      } else {
        return index % 2 == 0;
      }
    },
    // 清空输入框
    getRecentData() {
      this.searchValue1 = "";
      this.selectData == "PDJ_A" ? this.mySearchA() : this.mySearchB();
    },
    // 搜索
    chooseTable() {
      if (this.searchValue1 == "") return;
      // this.$emit("searchData", this.searchValue1);
      this.FtableData = this.tableData.filter((item) => {
        return item.eqpName.includes(this.searchValue1.toUpperCase());
      });
    },
  },
};
</script>

<style lang="scss">
.top-input-ele {
  .el-input {
    width: 189px;
    height: 32px;
    .el-input__suffix {
      position: absolute;
      top: -3px;
    }
    .el-input__inner {
      padding-left: 12px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      height: 32px;
      border-radius: 0;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;
      line-height: 21px;
    }
  }
}
</style>
<style lang="scss" scoped>
.itemSelect {
  background: rgba(45, 130, 255, 0.6) !important;
}
.tab_list {
  margin-top: 20px;
}
.text-left {
  text-align: left !important;
}
.menoff {
  width: 416px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
}
.table-top {
  margin: 10px 20px;
  display: flex;
  align-items: center;
  height: 40px;
  .name {
    white-space: nowrap;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    color: #fff;
    margin-right: 27px;
  }
}
.table-search {
  display: flex;
  align-items: center;
  .top-select {
    width: 69px;
    height: 32px;
  }
  .top-btn {
    width: 52px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    cursor: pointer;
  }
}
.hidden-table {
  overflow: hidden;
}
.bot-table {
  // position: relative;
  height: 404px;
  overflow: hidden;
  margin: 10px 20px;
  .mens {
    height: 364px;
    overflow-x: hidden;
    // overflow: hidden;
  }
  .custom-table-header {
    width: 100%;
    height: 42px;
    background: rgba(255, 255, 255, 0.1);
    display: grid;
    grid-template-columns: 70px 86px 220px;
    overflow: hidden;
    .table-column-item {
      height: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      cursor: pointer;
      .text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        .text-name {
          color: #ffffff;
          line-height: 18px;
          font-size: 14px;
        }
        .text-unit {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          line-height: 11px;
          transform: scale(0.83);
        }
        .text-img {
          margin-left: 2px;
          width: 6px;
          height: 10px;
          background-image: url("../../../../../../../assets/cut/down.png");
          background-size: cover;
        }
        .text-img-up {
          transform: rotate(180deg);
        }
      }
    }
  }
  .custom-table-body {
    flex-grow: 1;
    position: relative;
    .custom-table-wrap {
      position: absolute;
      top: 0;
      left: 0;
    }
    .custom-table-item {
      width: 376px;
      height: 46px;
      overflow: hidden;
      display: grid;
      grid-template-columns: 70px 86px 220px;
      text-align: center;
      align-items: center;
      div {
        font-size: 14px;
      }
      div:nth-child(3) {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .table-column-item {
        border: 1px solid;
        text-align: center;
        word-break: break-all;
        white-space: pre-wrap;
        line-height: 18px;
        display: -webkit-box; //谷歌
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; //显示几行
        overflow: hidden;
      }
      .text {
        font-size: 14px;
        line-height: 18px;
      }
      .table-column-properties {
        flex: 0;
      }
    }
  }
  .bot-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 404px;
    overflow: hidden;
    .bot-bg-hidden {
      background-image: url("../../../../../../../assets/public/not-show.png");
      background-size: cover;
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      .loading {
        width: 36px;
        height: 36px;
        position: relative;
        font-size: 12px;
      }
      .outer,
      .middle,
      .inner {
        border: 3px solid transparent;
        border-top-color: #d9d9d9;
        border-right-color: #d9d9d9;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
      }

      .outer {
        width: 3.5em;
        height: 3.5em;
        margin-left: -1.75em;
        margin-top: -1.75em;
        animation: spin 4s linear infinite;
      }

      .middle {
        width: 2.1em;
        height: 2.1em;
        margin-left: -1.05em;
        margin-top: -1.05em;
        animation: spin 3s linear reverse infinite;
      }

      .inner {
        width: 0.8em;
        height: 0.8em;
        margin-left: -0.4em;
        margin-top: -0.4em;
        animation: spin 2s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
    .noData {
      background-image: url("../../../../../../../assets/public/noData.png");
    }
    .bot-bg-name {
      margin-top: 14px;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #afafaf;
    }
  }
}
</style>
